import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  rewards: {
    data: [],
    meta: {
      total: 0,
    },
  },
};

// TODO: fetch all the rewards
export const fetchRewards = createAsyncThunk(
  "fetchRewards/rewards",
  async ({ enqueueSnackbar, limit, page }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`settings/rewards`, {
        params: {
          page: page + 1,
          limit,
        },
      });

      return {
        data: response.data.data.items,
        meta: {
          total: response.data.data.items.length,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: create reward
export const createReward = createAsyncThunk(
  "createReward/rewards",
  async ({ data, enqueueSnackbar, handleClose }, thunkApi) => {
    try {
      const response = await axiosInstance.post(`settings/rewards`, data);

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: update reward
export const updateReward = createAsyncThunk(
  "updateReward/rewards",
  async ({ data, enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(
        `settings/rewards/${id}`,
        data
      );

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: delete reward
export const deleteReward = createAsyncThunk(
  "deleteReward/rewards",
  async ({ enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      await axiosInstance.delete(`settings/rewards/${id}`);
      return {
        data: id,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const rewardslice = createSlice({
  name: "reward",
  initialState,
  extraReducers: (builder) => {
    // TODO: create reward
    builder.addCase(fetchRewards.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchRewards.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.rewards = action.payload;
    });

    builder.addCase(fetchRewards.rejected, (state, action) => {
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: create reward
    builder.addCase(createReward.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createReward.fulfilled, (state, action) => {
      state.isLoading = false;
      state.rewards.data = [action.payload.data, ...state.rewards.data];
      state.rewards.meta.total = state.rewards.meta.total + 1;
      action.payload.enqueueSnackbar("Reward is created successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(createReward.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: update reward
    builder.addCase(updateReward.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateReward.fulfilled, (state, action) => {
      state.isLoading = false;
      state.rewards.data = state.rewards.data.map((reward) => {
        if (reward.id === action.payload.data.id) {
          return action.payload.data;
        } else {
          return reward;
        }
      });
      action.payload.enqueueSnackbar("Reward is updated successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(updateReward.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: delete reward
    builder.addCase(deleteReward.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteReward.fulfilled, (state, action) => {
      state.isLoading = false;
      state.rewards.data = state.rewards.data.filter(
        (reward) => reward.id !== action.payload.data
      );
      action.payload.enqueueSnackbar("Reward is deleted successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(deleteReward.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });
  },
});

export default rewardslice.reducer;
